
window.SetupSildeTriggers = function() {

	//console.log('Setting up Slide Annimation Triggers...');

	function isScrolledIntoView(el) {
		var rect = el.getBoundingClientRect();
		var elemTop = rect.top;
		var elemBottom = rect.bottom;

		// Only completely visible elements return true:
		var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
		// Partially visible elements return true:
		//isVisible = elemTop < window.innerHeight && elemBottom >= 0;
		return isVisible;
	}

	var slides = document.querySelectorAll('.slide');

	window.addEventListener('scroll', function (e) {
		
		for (var i = 0; i < slides.length; i++) {
			var el = slides[i];
			if (isScrolledIntoView(el)) {
				if (!el.classList.contains('go-in')) {
					//this.console.log('going in...');
					el.classList.add('go-in');
					el.classList.remove('go-out');
				}
			} else {
				if (el.classList.contains('go-in')) {
					//this.console.log('going out...')
					el.classList.remove('go-in');
					el.classList.add('go-out');
				}
			}
		}
	});
}

if (document.readyState !== 'loading') {
	window.SetupSildeTriggers();
} else {
	document.addEventListener('DOMContentLoaded', function () {
		window.SetupSildeTriggers();
	});
}